import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import 'url-search-params-polyfill'
// import * as PATHS from 'src/router/paths'
// import * as MODES from 'src/config/modes'
//import AnalyticsService from '@/services/AnalyticsService'

// URL PARAMS
let urlParams = new window.URLSearchParams(window.location.search)

// DEBUG
let debug = process.env.NODE_ENV !== 'production'
// debug = false
if (urlParams.get('_debug') !== null) debug = true
if (urlParams.get('_debug') === 'false') debug = false

// VCONSOLE
let vconsole = process.env.NODE_ENV !== 'production'
vconsole = false
if (urlParams.get('_vconsole') !== null) vconsole = true
if (urlParams.get('_vconsole') === 'false') vconsole = false

// STATE
const state = {
  // version: pack.version,
  debug: debug,
  vconsole: vconsole,

  // LOADING
  loading: {
    step: '',
    progress: 0,
    completed: false,
  },
  resize: {
    safePadding: 0,
  },
  sysInfo: {
    app: 'alipay',
    brand: 'IPHONE',
    currentBattery: '100%',
    fontSizeSetting: 16,
    language: 'zh-Hans',
    model: 'iPhone X',
    pixelRatio: 3,
    platform: 'iOS',
    screenHeight: 812,
    screenWidth: 375,
    statusBarHeight: 44,
    storage: '62.42G',
    system: '6.0.1',
    titleBarHeight: 44,
    version: '10.1.55',
    windowHeight: 724,
    windowWidth: 375,
  },
  router: {
    back: '/',
    last: '/',
  },
  //systemBarHeight: 64,
  user: {},
  scheduleTable: [],
  schedules: [],
  calenders: [],
  fam: {
    adult: null,
    kid1: null,
    kid2: null,
  },

  schedulePicked: null,
  ticketPicked: null,

  ageWarning: false,
  ageWarningShowed: false,

  pending: false,

  appStatus: 0,

  showQueuePanel: false,

  invCode: null,
  inviter: null,
  showInvPopup: false,
  showLatestResPopup: false,
  showCharityPopup: false,

  mpEventList: [],
  // res: {
  //   dayPick:
  // }

  footprintServiceTime: '',
  footprintQrcode: {},
  footprintTaskListToday: {
    branchTask: [],
    masterTask: [],
  },
}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
